const shouldHideVariantButtonsSelectorUtil = (props) => {
  const {
    isGiftUrl,
    isAddAGiftCardStep,
    isSelfGifting,
    isSampleCollection,
    isSampleSubCollection
  } = props

  return (
    isGiftUrl ||
    isAddAGiftCardStep ||
    isSelfGifting ||
    isSampleCollection ||
    isSampleSubCollection
  )
}

export default shouldHideVariantButtonsSelectorUtil
